// Centralized environment configuration for frontend
// Reads API base URL from CRA env var and normalizes it (no trailing slash)

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

// Remove any trailing slashes to avoid double slashes when joining paths
let normalizedBaseUrl = rawBaseUrl.replace(/\/+$/, "");

// Ensure the URL has a protocol (http:// or https://)
// If it doesn't start with a protocol, prepend https://
if (!normalizedBaseUrl.match(/^https?:\/\//i)) {
  normalizedBaseUrl = `https://${normalizedBaseUrl}`;
}

// Exported as requested name while following CRA env constraints
export const config_base_url: string = normalizedBaseUrl;

// Helper for composing URLs safely
export const withBaseUrl = (path: string): string => {
  if (!path) return config_base_url;
  return path.startsWith("/") ? `${config_base_url}${path}` : `${config_base_url}/${path}`;
};

export default config_base_url;
